import React from 'react'
import { Link } from 'react-router-dom'
import icon from '../../img/icon.png'

class Navbar extends React.Component {
	
	render() {
		
		return (
			<section id="navbar">
				<div className="container">
					<nav className="navbar navbar-horizon">
						<div className="left d-flex align-items-center">
							<Link className="icon" to={"/"}><img src={ icon } /></Link>
							<Link className="title" to={"/"}>
								<strong>The Flight Post</strong>
								<span>Your destination for trip reports</span>
							</Link>
						</div>
						<ul className="navbar-nav ml-auto">
							<li className="nav-item mr-2">
								<Link className="btn btn-link-o" to="/">Go Home</Link>
							</li>
						</ul>
					</nav>
				</div>
			</section>
		)
	}
}

export default Navbar


// WEBPACK FOOTER //
// ./src/components/Reset/Navbar.js